import { useEffect, useState } from "react";
import Modal from "../../../layouts/Modal";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";

interface IBestOfferResetModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (percent: number, useCategoryThreshold: boolean) => void;
  isLoading: boolean;
}

export default function BestOfferResetModal({ open, onClose, onConfirm, isLoading }: IBestOfferResetModalProps) {
  const [percent, setPercent] = useState<number>(10);
  const [useCategoryThreshold, setUseCategoryThreshold] = useState<boolean>(true);

  // Reset to defaults each time the modal opens
  useEffect(() => {
    if (open) {
      setPercent(10);
      setUseCategoryThreshold(true);
    }
  }, [open]);

  return (
    <Modal open={open} setOpen={onClose} width="max-w-md">
      <div className="space-y-4">
        <h2 className="text-lg font-medium leading-6 text-gray-900">Reset Best Offer Auto-Accept</h2>
        <p className="text-sm text-gray-600">
          Recalculate the Best Offer auto-accept price for the selected listings based on their
          current Buy It Now price. Listings without Best Offer enabled are skipped.
        </p>
        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium text-gray-700">
            Accept offers this % below Buy It Now
          </label>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={1}
              max={99}
              value={percent}
              onChange={(e) => setPercent(Number(e.target.value))}
              className="h-10 w-28 rounded-md border border-gray-300 px-3 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
            />
            <span className="text-sm text-gray-500">% below Buy It Now</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <input
            id="bestOfferUseCategoryThreshold"
            type="checkbox"
            checked={useCategoryThreshold}
            onChange={(e) => setUseCategoryThreshold(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          <label htmlFor="bestOfferUseCategoryThreshold" className="text-sm text-gray-700">
            Use Category Default Threshold Where Available
          </label>
        </div>
        <div className="flex justify-end gap-4 border-t pt-4">
          <ButtonInput label={"Cancel"} isSubmit={false} onClick={onClose} classes={"!bg-gray-200 hover:!bg-gray-300 !text-gray-700"} />
          <ButtonInput label={"Reset Best Offer"} isSubmit={false} onClick={() => onConfirm(percent, useCategoryThreshold)} classes={undefined} isLoading={isLoading} />
        </div>
      </div>
    </Modal>
  );
}
